import { Body } from "./patient_rights/components/Body";
import { Footer } from "./footer/NewFooter";
import { Heading3XL } from "../typography";
import ProviderNavigation from "../ProviderNavigation";
import ScrollToTop from "../ScrollToTop";

export default function PatientRightsPage() {
  return (
    <div>
      <ScrollToTop />
      <ProviderNavigation />
      <div className="tw-mx-auto tw-mb-[4em] tw-mt-[3em] tw-flex tw-max-w-[768px] tw-flex-col tw-gap-y-[4em] tw-px-[1.25em]">
        <Heading3XL className="tw-my-0 tw-text-center tw-text-blue-dark-3">
          Patient Rights and Responsibilities
        </Heading3XL>
        <div className="tw-flex tw-flex-col tw-gap-y-[3em]">
          <Body />
        </div>
      </div>
      <Footer />
    </div>
  );
}
